export * from './platform';
export * from './text';
export * from './link';
export * from './connect';
export * from './switch_lang';
export * from './button';
export * from './textinput';
export * from './scene';
export * from './avatar';
export * from './header';
export * from './badge';
export * from './list_item';
export * from './flat_list';
export * from './modal';
export * from './status_box';
export * from './alert';
export * from './action_sheet';
export * from './confirm_box';
export * from './upload_progress';
export * from './action_sheet_button';
export * from './date_picker';
export * from './timestamp';
export * from './text_area';
export * from './web_browser';
export * from './tooltip';
export * from './checkbox';
export * from './radio_group';
export * from './cached_image';
export * from './tab_navigator';
export * from './file_picker';
export * from './video';
export * from './media_viewer';
export * from '../../containers/AppHeader';
export * from './tel_picker';
export * from './search_box';
export * from './confirmation_code_input';

export {
    View,
    I18nManager,
    ActivityIndicator,
    ActionSheetIOS,
    Animated,
    Easing,
    AsyncStorage,
    ScrollView,
    Picker,
    Switch,
    Linking,
    WebView,
    Vibration,
    Clipboard,
    Dimensions,
    VirtualizedList,
    Image,
    StatusBar
} from 'react-native';



// WEBPACK FOOTER //
// ./src/components/core/index.js